import {
  addWorkspaceToProject,
  assignableProjects,
  createWorkspace,
  deleteWorkspace,
  duplicateWorkspace,
  getWorkspaceDetails,
  getWorkspacesOfProject,
  loadWorkspaces,
  removeWorkspaceFromProject,
  removeWorkspacePassword,
  removeWorkspaceUsers,
  setWorkspacePassword,
  toggleWorkspaceVisibility,
  updateWorkspaceLabels,
  updateWorkspaceName,
  upsertWorkspaceUsers,
} from "./workspaces.actions";

/**
 * actions to automatically cause a token-refresh on 401 and then be re-tried also by default produces error message on any other error
 */
export const retryableFailures = [
  addWorkspaceToProject.failure,
  assignableProjects.failure,
  createWorkspace.failure,
  deleteWorkspace.failure,
  duplicateWorkspace.failure,
  getWorkspaceDetails.failure,
  getWorkspacesOfProject.failure,
  loadWorkspaces.failure,
  removeWorkspaceFromProject.failure,
  removeWorkspacePassword.failure,
  removeWorkspaceUsers.failure,
  setWorkspacePassword.failure,
  toggleWorkspaceVisibility.failure,
  updateWorkspaceLabels.failure,
  updateWorkspaceName.failure,
  upsertWorkspaceUsers.failure,
];
